import RETRY_STATUS from '@/constants/retry-status'
import { getCurrentTimestamp } from '@/utils/timestamp'

const DELAY_TIMEOUT = [0, 3000, 9000, 15000, 30000]

const getDelayTimeoutMS = (counter) => {
  return counter < DELAY_TIMEOUT.length ? DELAY_TIMEOUT[counter] : -1
}

const state = {
  count: 0,
  latest: getCurrentTimestamp(),
  status: RETRY_STATUS.none,
  timeoutMs: null,
}

const getters = {
  delayTimeoutMS(state) {
    return state.timeoutMs || getDelayTimeoutMS(state.count)
  },
}

const mutations = {
  SET_STATUS(state, status) {
    state.status = status
  },
  SET_COUNTER(state, count) {
    state.count = count
  },
  SET_TIMEOUT(state, timeoutMs) {
    state.timeoutMs = timeoutMs
  },
  SET_LATEST_TIME(state, latest) {
    state.latest = latest
  },
}

const actions = {
  retryRequest({ commit, state }) {
    const counter = state.count + 1
    const timeout = getDelayTimeoutMS(counter)

    commit('SET_COUNTER', state.count + 1)
    commit('SET_LATEST_TIME', getCurrentTimestamp())

    if (timeout > -1) {
      commit('SET_STATUS', RETRY_STATUS.retrying)
    } else {
      commit('SET_STATUS', RETRY_STATUS.error)
    }

    return true
  },
  updateTimeoutMs({ commit }, timeoutMs) {
    commit('SET_TIMEOUT', timeoutMs)
  },
  retryNow({ commit }) {
    commit('SET_STATUS', RETRY_STATUS.retrying)
  },
  retrySuccess({ commit, dispatch }) {
    commit('SET_STATUS', RETRY_STATUS.success)

    setTimeout(() => {
      dispatch('resetStatus')
    }, 1500)
  },
  retryError({ commit }) {
    commit('SET_COUNTER', 0)
    commit('SET_STATUS', RETRY_STATUS.error)
  },

  resetStatus({ commit }) {
    commit('SET_COUNTER', 0)
    commit('SET_STATUS', RETRY_STATUS.none)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
